import { useEffect, useState } from 'react'; 
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import "../../sass/_favRecRecords.scss";
import { createTheme, ThemeProvider } from '@mui/material';

const theme = createTheme({
    components: {
        MuiTab: {
            styleOverrides: {
                root: {
                    color: 'black',
                    borderBottom: 'none',
                    borderRadius: '8px 8px 0 0',
                    backgroundColor: '#E6EDF1',
                    marginTop: '8px',
                    marginRight: '4px',
                    textTransform: "none",
                    minHeight:"unset",
                    fontSize:"14px",
                    lineHeight:"24px",
                    "font-family": "Roboto regular, Helvetica, Arial, sans-serif",
                    '&.Mui-selected': {
                        color: 'black',
                        backgroundColor: 'white',
                        "font-family": "Roboto medium, Helvetica, Arial, sans-serif"
                    },
                },
            },
        },
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    display: 'none',
                },
            },
        }
    },
});

const PageTabsCopy = ({ value, setValue, tabList }) => {
    // state for tab index
    const [tabIndex, setTabIndex] = useState(0); 
    // event handler for tab change
    const handleChange = (e, newVal) =>{; 
        setValue(value => value = tabList[newVal]['key']);
        setTabIndex(tabIndex => tabIndex = newVal)
    }

    useEffect(() => {
        console.log(value); 
    }, [value]); 

    return (
      // material ui tabs component
      <ThemeProvider theme={theme}>
        <Tabs
          value={tabIndex}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className="tab-bg"
          sx={{borderRadius:"12px 12px 0 0", backgroundColor: process.env.REACT_APP_PRIMARY_COLOR}}
          TabIndicatorProps={{ style: { display: "none" } }}
        >
          {tabList.map((el) => (
            <Tab label={el["tag"]} disableRipple />
          ))}
        </Tabs>
      </ThemeProvider>
    );
}

export default PageTabsCopy